import React from 'react';
import { Button } from '../../components/ui/button';
import { Phone } from 'lucide-react';
import CardGrid from '../../components/CardGrid';
import { tecnalData } from '../../data/tecnal';
import './TECNALPage.css';

const TECNALPage = () => {
  const whatsappNumber = '5493413047536';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=¡Hola!`;
  const data = tecnalData.tecnal;

  return (
    <div className="tecnal-landing-container">
      {/* Hero Section */}
      <section className="tecnal-landing-hero">
        <div className="tecnal-landing-hero-image">
          <img
            src="/assets/tecnal/tecnal_header.webp"
            alt="TECNAL equipos industriales"
            loading="lazy"
          />
          <div className="tecnal-landing-hero-overlay" />
        </div>
        <div className="tecnal-landing-hero-content">
          <h1 className="tecnal-landing-hero-title">{data.title}</h1>
          {data.intro && data.intro.map((paragraph, idx) => (
            <p key={idx} className="tecnal-landing-hero-intro">{paragraph}</p>
          ))}
        </div>
      </section>

      {/* Dynamic Sections */}
      {data.sections && data.sections.map((section, idx) => {
        const isReferencias = section.heading === 'Principales referencias en el mundo';
        return (
          <section
            key={idx}
            id={isReferencias ? 'referencias' : undefined}
            className="category-section"
          >
            <div className="container">
              {section.heading && (
                <h2 className="section-title">{section.heading}</h2>
              )}
              <CardGrid cards={section.cards} />
            </div>
          </section>
        );
      })}

      {/* CTA Section */}
      <section className="category-cta-section">
        <div className="container">
          <h2 className="category-cta-title">
            Representamos tecnología que potencia la eficiencia y confiabilidad de tus procesos.
          </h2>
          <Button
            size="lg"
            className="category-cta-button"
            onClick={() => window.open(whatsappLink, '_blank')}
          >
            <Phone className="mr-2" size={20} />
            Contactanos
          </Button>
        </div>
      </section>
    </div>
  );
};

export default TECNALPage;
